export default "__VITE_ASSET__EZ_QQ$uX__";